import { Pipe, type PipeTransform } from '@angular/core';
import { VATCategoryType } from '@shared/zigra-schemas/zigra-schema.autogenerated.models';

@Pipe({
    name: 'appTaxFilter'
})
export class TaxFilterPipe implements PipeTransform {
    transform(
        vatCategories: VATCategoryType[] | undefined,
        ...args: unknown[]
    ) {
        return vatCategories?.filter(
            (vatCategory) =>
                vatCategory.Code == 1 ||
                vatCategory.Code == 2 ||
                vatCategory.Code == 3
        );
    }
}
